package gr.tech.GRAttestation.components.layouts

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.foundation.layout.*
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.core.PageContext
import com.varabyte.kobweb.core.rememberPageContext
import gr.tech.GRAttestation.components.widgets.loadingSpinnerMaxSize
import gr.tech.GRAttestation.infrastructure.api.checkStoreUserJWT
import gr.tech.GRAttestation.infrastructure.api.storeUserLogout
import gr.tech.GRAttestation.infrastructure.session.StoreUserSession
import gr.tech.GRAttestation.models.user.USER_ROLES
import gr.tech.GRAttestation.navigation.SitePage
import gr.tech.GRAttestation.sections.store.StoreUserNavHeader
import kotlinx.browser.document
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.vw

@Composable
fun StoreUserPageLayout(
    title: String = "Green Rebates",
    redirectIfLoggedIn: String? = null,
    requiredRoles: List<String> = listOf(USER_ROLES.CONFIRMED_USER.role),
    content: @Composable ColumnScope.(ctx: PageContext) -> Unit
) {
    val scope = rememberCoroutineScope()
    val ctx = rememberPageContext()
    var hasValidAccess by remember { mutableStateOf(StoreUserSession.checked.value) }

    LaunchedEffect(Unit) {
        document.title = title

        if (!hasValidAccess) {
            val userPreviewInfo = checkStoreUserJWT(
                redirectLogin = false,
                redirectTo = SitePage.Login.route
            )
            if (userPreviewInfo.success && userPreviewInfo.data != null) {
                StoreUserSession.info.value = userPreviewInfo.data
            } else {
                StoreUserSession.info.value = null
            }

            StoreUserSession.checked.value = true
        }

        val isLoggedIn = StoreUserSession.isLoggedIn()

        // ----- REDIRECTION LOGIC -----

        // If the user is logged-in and you provided a redirect path (e.g. from login/signup),
        // send them there instead of letting them access this page.
        if (isLoggedIn && redirectIfLoggedIn != null) {
            ctx.router.tryRoutingTo(redirectIfLoggedIn)
            return@LaunchedEffect
        }

        // If user is not logged in and auth is required, bounce to login
        if (!isLoggedIn && requiredRoles.isNotEmpty()) {
            ctx.router.tryRoutingTo(SitePage.Login.route)
            return@LaunchedEffect
        }

        hasValidAccess = true
    }


    Box(
        Modifier
            .width(100.vw)
            .minHeight(100.percent),
        contentAlignment = Alignment.Center
    ) {
        Row(
            Modifier.fillMaxSize(),
            horizontalArrangement = Arrangement.Start
        ) {
            if (hasValidAccess || (requiredRoles.isEmpty())) {
                Column(
                    modifier = Modifier.fillMaxSize(),
                    horizontalAlignment = Alignment.CenterHorizontally
                ) {
                    // Navbar at the top
                    StoreUserNavHeader(
                        onLogout = { scope.launch { storeUserLogout() } }
                    )

                    // Content area - scrollable
                    Column(
                        Modifier
                            .fillMaxWidth()
                            .weight(1f)
                            .overflow(Overflow.Auto),
                        horizontalAlignment = Alignment.CenterHorizontally
                    ) {
                        content(ctx)
                    }
                }
            } else {
                loadingSpinnerMaxSize()
            }
        }
    }
}